/**
 * @desc checkSupplierAccount
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierAccountDetailsImpl.checkSupplierAccount.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/checkSupplierAccount`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
